import Modal from "react-bootstrap/Modal";
import usePageLanguage from "../hooks/usePageLanguage";
import React from "react";
import "../ShoppingCart/ShoppingCartExpired.css";

interface Props {
  show: boolean;
  setShow: (val: boolean) => void;
  messageKey?: "validation" | "prepare";
  /** Server or API error text; shown instead of the default message when set. */
  detailMessage?: string;
}

const languageTranslations = {
  et: {
    validation: {
      title: "VALIDEERIMINE EBAÕNNESTUS",
      message:
        "Tellimuse esitamine ebaõnnestus. Palun kontrolli oma tellimust.",
    },
    prepare: {
      title: "TELLIMUSE ETTEVALMISTAMINE EBAÕNNESTUS",
      message:
        "Tellimuse andmete laadimine ebaõnnestus. Palun kontrolli ühendust ja proovi uuesti.",
    },
    ok_button: "OK",
  },
  en: {
    validation: {
      title: "ORDER VALIDATION FAILED",
      message: "Order submission failed. Please check your order.",
    },
    prepare: {
      title: "ORDER PREPARATION FAILED",
      message:
        "Could not load order details. Please check your connection and try again.",
    },
    ok_button: "OK",
  },
};

export default function CheckoutErrorModal({
  show,
  setShow,
  messageKey = "validation",
  detailMessage,
}: Props) {
  const locale = usePageLanguage();
  const copy =
    languageTranslations[locale]?.[messageKey] ??
    languageTranslations.et[messageKey];

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      contentClassName="modal-600 shop-controlled-border-radius"
    >
      <Modal.Header
        closeButton
        style={{
          background: "#f9f9f9",
          borderTopLeftRadius: "var(--shop-border-radius)",
          borderTopRightRadius: "var(--shop-border-radius)",
        }}
      >
        <Modal.Title>
          <span className="fw-bold ">{copy.title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-left">
          <p>{detailMessage?.trim() || copy.message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <button
          type="button"
          onClick={handleClose}
          style={{
            color: "#fff",
          }}
          className="btn w-100 shop-controlled-color shop-controlled-border-radius"
        >
          {languageTranslations[locale]?.ok_button}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
